// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"53":"c8527d08d04938f49f5d","132":"ba5327c52709a90668fb","265":"bc8672056a736211f7fb","460":"203168477a5573ed5f44"}[chunkId] + ".css";
};